<template lang="html">

  <section class="section">

    <HeaderSection :title="$t('components.progressGroupSla.sla')">
    </HeaderSection>
    <table class="table">
      <div @click="toggleTable" class="toggle-sla-table">
        <span v-if="!seeMore">{{ $t('components.progressGroupSla.more') }}</span>
        <span v-else>{{ $t('components.progressGroupSla.less') }}</span>
      </div>
      <thead>
        <tr>
            <th class="size-12">{{ $t('components.progressGroupSla.status') }}</th>
            <th v-for="service in services" :key="service.key">
              <span class="cercle inline-block" :class="colorClass(service.key)"></span>{{service.name}}
            </th>
        </tr>
      </thead>
      <tbody v-if="seeMore">
          <tr v-for="(sla, index) in sla" :key="index">
            <td style="text-transform: capitalize" :class="{'is-gray-700': index !=0}">{{ getMonthLocale(sla.month) }}</td>
            <td>
              <div class="td-label">
                {{ $t('components.progressGroupSla.agility') }}
              </div>
              <div class="td-content" :class="{'is-gray-700': index !=0}">
                <div class="cercle inline-block" :class="colorClass('sla_agility', index)"></div>{{sla.sla_agility == 100 ? 100 : sla.sla_agility}} %
              </div>
            </td>
            <td>
              <div class="td-label">
                {{ $t('components.progressGroupSla.director') }}
              </div>
              <div class="td-content" :class="{'is-gray-700': index !=0 }">
                <div class="cercle inline-block" :class="colorClass('sla_director', index)"></div>{{sla.sla_director == 100 ? 100 : sla.sla_director}} %
              </div>

            </td>
            <td>
              <div class="td-label">
                {{ $t('components.progressGroupSla.backup') }}
              </div>
              <div class="td-content" :class="{'is-gray-700': index !=0}">
                <div class="cercle inline-block" :class="colorClass('sla_backup', index)"></div>{{sla.sla_backup == 100 ? 100 : sla.sla_backup}} %
              </div>
            </td>
          </tr>
      </tbody>
    </table>
</section>

</template>

<script>

import HeaderSection from '@/components/HeaderSection.vue';
import ProgressStandalone from '@/components/ProgressStandalone.vue';
import moment from 'moment';

export default {
  name: 'ProgressGroupSla',
  components: {
    HeaderSection,
    ProgressStandalone,
  },
  props: {
    sla: {
      type: Array,
      required: true,
    },
    agility: {
      type: Boolean,
      required: true,
    },
    backup: {
      type: Boolean,
      required: true,
    },
    director: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {

  },
  data() {
    return {
      seeMore: false,
      services: [
        {
          name: this.$t('components.progressGroupSla.agility'),
          key: 'sla_agility',
        },
        {
          name: this.$t('components.progressGroupSla.director'),
          key: 'sla_director',

        },
        {
          name: this.$t('components.progressGroupSla.backup'),
          key: 'sla_backup',

        },
      ],
    };
  },
  created() {
    moment.locale(this.$i18n.locale);
  },
  methods: {
    getMonthLocale(month) {
      return moment(month).format('MMMM YYYY');
    },
    toggleTable() {
      this.seeMore = !this.seeMore;
    },

    colorClass(service, index = 0) {
      if (this.sla[index][service] < 99) {
        return 'bg-danger';
      } if (this.sla[index][service] >= 99.9) {
        return 'bg-success';
      }
      return 'bg-warning';
    },

  },
  computed: {
  },
};
</script>

<style lang="scss">
.toggle-sla-table {
  text-decoration: underline;
  position: absolute;
  right: 15px;
  top: 45px;
  color: $gray-700;
  cursor: pointer;
  z-index: 1;
}
.cercle {
    width: 8px;
    height: 8px;
    border-radius: 80px;
    margin-right: 5px;
}
.bg-danger {
  background: $danger;
}
.bg-success {
  background: $success;
}
.bg-warning {
  background: $warning;
}
.size-12 {
  font-size: 12px !important;
}
</style>
